import React, { useEffect, useState } from 'react';
import { useUpdateMembershipEvent, useGetMembershipEvent } from 'api/membership-events';
import { CircularProgress, Grid, Button, FormControl, FormHelperText, Box } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useQueryClient } from 'react-query';
import MembershipEventsWrapper from './membership-events-wrapper';
import { Input, titlefy } from '../MembershipPerks/membership-perk-form-components';
import SCHEMA from '../../constants/SCHEMA.gen.json';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';

const {
  membership_event: { TITLE, SUMMARY, STARTS_AT, ENDS_AT, TIME_ZONE, LINK, ATTEND_URL },
} = SCHEMA;

const DateTimePickerInput = ({ name, onChange, value, title }) => {
  return (
    <Grid item xs={8}>
      <Box margin={'10px'}>
        <FormControl fullWidth={true}>
          <FormHelperText>{title || titlefy(name)}</FormHelperText>
          <DateTimePicker value={value} onChange={date => onChange({ target: { name: name, value: date } })} />
        </FormControl>
      </Box>
    </Grid>
  );
};

function MembershipEventEdit(props) {
  const id = props?.match?.params?.id;
  const queryClient = useQueryClient();
  const history = useHistory();

  const { data: membershipEventData, isLoading } = useGetMembershipEvent(id);
  const [form, setForm] = useState(membershipEventData || {});

  useEffect(() => {
    setForm(membershipEventData || {});
  }, [membershipEventData]);

  async function saveMembershipEvent(evt) {
    evt.preventDefault();
    await onSave(form);
  }

  const { mutate: updateMembershipEvent, isLoading: isSaving } = useUpdateMembershipEvent({
    onSuccess: async () => {
      await queryClient.invalidateQueries('getMembershipEvents');
      await queryClient.invalidateQueries(['getMembershipEvent', id]);
      history.push('/membership-events');
    },
  });

  function onSave(values) {
    const sanitizedValues = Object.entries(values).reduce((newValues, [key, value]) => {
      if (key === 'membership_event_id' || key === 'created_at' || key === 'updated_at' || key === 'mn_event')
        return newValues;
      return { ...newValues, [key]: value || '' }; //some items are null but require a string. This makes it where you can 'clear' an optional
    }, {});
    updateMembershipEvent(sanitizedValues);
  }

  function onChange({ target }) {
    const { name, value } = target;
    setForm({ ...form, [name]: value });
  }

  if (isLoading) return <CircularProgress />;

  return (
    <MembershipEventsWrapper>
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <Grid item xs={12}>
          <form onSubmit={saveMembershipEvent}>
            <Input name={TITLE} value={form[TITLE]} onChange={onChange} />
            <Input name={SUMMARY} minRows={4} value={form[SUMMARY]} onChange={onChange} />
            <Input name={LINK} value={form[LINK]} onChange={onChange} />
            <Input name={ATTEND_URL} value={form[ATTEND_URL]} onChange={onChange} />
            <DateTimePickerInput name={STARTS_AT} value={form[STARTS_AT]} onChange={onChange} />
            <DateTimePickerInput name={ENDS_AT} value={form[ENDS_AT]} onChange={onChange} />
            <Button type="submit" disabled={isSaving}>
              Save
            </Button>
            <Button disabled={isSaving} onClick={() => history.push('/membership-events')}>
              Cancel
            </Button>
          </form>
        </Grid>
      </MuiPickersUtilsProvider>
    </MembershipEventsWrapper>
  );
}

export default MembershipEventEdit;
